import api from '@/api';
import utilsActions from '@/utils/actions';

export default {
    namespaced: true,
    state: {
        list: [],
        error: null,
        errors: null,
        requestPending: false,
        page: 0,
        pagesize: 16,
        count: 0,
    },
    getters: {
        getById: (state) => (id) => state.list.find((item) => item.id === id),
    },
    mutations: {
        setList(state, list) {
            state.list = list;
        },
        clearError(state) {
            state.error = null;
        },
        setError(state, error) {
            state.error = error;
        },
        clearErrors(state) {
            state.errors = null;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        startRequest(state) {
            state.requestPending = true;
        },
        endRequest(state) {
            state.requestPending = false;
        },
        setPage(state, page) {
            state.page = page;
        },
        setPagesize(state, pagesize) {
            state.pagesize = pagesize;
        },
        setCount(state, count) {
            state.count = count;
        },
    },
    actions: {
        async list(context, payload) {
            const page = payload ? payload.page || 0 : 0;
            try {
                const response = await api.notifications.list(page, context.state.pagesize);
                context.commit('setPage', response.data.page);
                context.commit('setPagesize', response.data.pagesize);
                context.commit('setCount', response.data.count);
                context.commit('setList', response.data.data);
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    console.log(err);
                }
            }
        },
        async get(context, id) {
            const response = await api.notifications.item(id);
            return response.data.data;
        },
        async create(context, element) {
            await utilsActions.defaultAction(context, api.notifications.create(element));
        },
        async update(context, element) {
            await utilsActions.defaultAction(context, api.notifications.update(element.id, element));
        },
        async remove(context, id) {
            await utilsActions.defaultAction(context, api.notifications.remove(id));
        },
    },
};
